<template>
  <div class="w-full h-full fixed justify-center block top-0 left-0 bg-white opacity-75 z-50">
    <div class="flex-none items-center opacity-75 top-1/2 my-auto mx-auto block relative w-16 h-16" role="status">
      <Spinner
        message="Loading Data"
        :size="16"
      />
    </div>
  </div>
</template>

<script>
import Spinner from './Spinner.vue'

export default {
  components: {
    Spinner,
  },
  props: {
    globalDisplay: Boolean
  }
}
</script>
